export default "__VITE_ASSET__DpQ25zog__"